import React from 'react';
import PropTypes from 'prop-types';
import OverallPercent from './OverallPercent';
import ShowValue from './ShowValue';
import { BrowserOnly, PrintOnly } from 'cccisd-laravel-report';
import style from './style.css';

const Callout = props => {
    const { title, description, colors } = props.settings;

    return (
        <div
            className={style.wrapper}
            style={
                colors
                    ? {
                          border: `1px solid ${colors.primary}`,
                      }
                    : {}
            }
        >
            <div
                className={style.title}
                style={
                    colors
                        ? {
                              backgroundColor: colors.primary,
                          }
                        : {}
                }
            >
                {title}
            </div>
            <div className={style.description}>{description}</div>
            <div className={style.component}>
                <BrowserOnly>
                    <OverallPercent data={props.data} colors={colors} settings={props.settings} />
                </BrowserOnly>
                <PrintOnly>
                    <ShowValue data={props.data.adherence} colors={colors} />
                </PrintOnly>
            </div>
        </div>
    );
};

Callout.propTypes = {
    settings: PropTypes.object,
    handle: PropTypes.string,
    data: PropTypes.object,
};

Callout.defaultProps = {};

export default Callout;
